import React, { Component } from 'react'
import CopyIcon from '../icons/copyicon'
import Loader from './loader'
import AddFileIcon from '../icons/plusicon';
import Player from 'video-react/lib/components/Player';
import ControlBar from 'video-react/lib/components/control-bar/ControlBar';
import PlayToggle from 'video-react/lib/components/control-bar/PlayToggle';

export default class UploadVideo extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            imagePreloader:false
        }
    }
    componentDidMount() {
        
    }
    
    render() {
        return (
                <div className="uploads_files">
                    <div className="media_image mb_0 absolute_loader relative">
                        {this.state.imagePreloader ?
                            <Loader />
                        :""
                    }
                    {/* <img src = "./user.png" alt="image" /> */}

                    <div className="form_group_video_wpr">
                        {/* <iframe src="https://www.youtube.com/embed/tgbNymZ7vqY" /> */}
                        <Player
                            playsInline
                            autoPlay={false}
                            type="video/mp4"
                            src='https://www.w3schools.com/html/mov_bbb.mp4'
                            >
                            <ControlBar autoHide={false} disableDefaultControls={true}>
                                <PlayToggle />
                            </ControlBar>
                        </Player>
                    </div>

                <span className="upload_message">Upload PNG/JPEG of max size of {this.props.size}MB</span>
                        <div className="input_file">
                            <input 
                                type="file" 
                                // id={item._id}
                                ref={(ref) => this.uploadOne = ref}
                                style={{display: 'none'}}
                                // onChange={(e)=>this.handleImage(e,item._id)}
                                accept=".png, .jpg, .jpeg"
                                />
                            <span onClick={()=>{this.uploadOne.click()}}><AddFileIcon /></span>
                        </div>
                    </div> 
                    <div className="field_row">
                    <div className="field_input relative">
                        <input 
                            type="text" 
                            placeholder="https://cloudfront.aws.com/sdf2345"
                            name='inSite'
                            // id={item._id}
                            // defaultValue={item.inSite}
                            // onChange={(e)=>this.insideOnchange(e,item._id)}
                        />
                        <span className="copy_box">
                            <CopyIcon />
                        </span>
                        </div>
                    </div>  
                </div>
        )
    }
}
